<template>
  <div class="warning__container">
    <div class="warning__icon-box">
      <v-icon class="bexsicon-info" color="#DC2C34"/>
    </div>
    <div class="warning__message">
      {{message}}
      <slot name="link" v-bind="{message, messageLink, linkPath}">
        <a class="warning__message-link" :href="linkPath">
          {{messageLink}}
        </a>
      </slot>

    </div>
  </div>
</template>

<script>
export default {
props: {
  message: String,
  messageLink: String,
  linkPath: String
}
}
</script>

<style lang="scss" scoped>
.warning__container{
  border: solid red 1px;
  border-radius: 6px;
  display: flex;
  padding: 5px;
  margin: 15px;
}

.warning__icon-box{
  margin: 1rem;
}

.warning__message{
  color: red;
}

.warning__message-link{
  color: red;
  font-weight: bold;
  text-decoration: underline;
}

</style>


// WEBPACK FOOTER //
// ./src/components/Warning.vue